export const REGEX = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9-]+(?:\.[A-Z0-9-]+)*\.[A-Z]{2,}$/i,
  HALFWIDTH: /^[\u0020-\u007E]+$/,
  INCLUDE_NUMBER: /[0-9０-９.,]/,
  INCLUDE_NUMBER_ONLY: /^[0-9０-９.,]+$/,
  INCLUDE_ALPHABET: /[a-zA-Z]/,
  INCLUDE_NUMBER_ONLY_AND_STRING_EMPTY: /^[0-9.,]*$/,
  INCLUDE_ALPHABET_ONLY: /^[a-zA-Z]+$/,
  INCLUDE_LATIN: /^[a-zA-Z0-9.,\s]+$/,
  INCLUDE_LATIN_ONLY: /^[a-zA-Z0-9\s]+$/,
  NUMERIC_FORMAT: (precision: number, scale: number) => {
    const integerDigits = precision - scale;
    const integerPart = `\\d{1,${integerDigits}}`;
    const decimalPart = scale > 0 ? `(\\.\\d{1,${scale}})?` : "";
    return new RegExp(`^-?${integerPart}${decimalPart}$`);
  },
};

export const MESSAGE = {
  INVALID_EMAIL: "メールアドレスの形式が無効です",
  EMPTY_EMAIL: "メールアドレスは必須です",
  EMPTY_PASSWORD: "パスワードは必須です",
  NOT_SAME_PASSWORD: "新規パスワードと新規パスワード（確認）が一致していません。",
  VALIDATION_PASSWORD: (length: number): string =>
    `パスワードは半角英数にて${length}桁以上で設定してください。`,
  EMPTY: "必須項目です",
  HALFWIDTH: "半角文字で入力してください",
  INCLUDE_NUMBER: "数字を含めてください",
  INCLUDE_NUMBER_ONLY: "数字のみで入力してください",
  INCLUDE_ALPHABET: "英字を含めてください",
  INCLUDE_ALPHABET_ONLY: "英字のみで入力してください",
  MAX_LENGTH: (length: number): string => `${length}文字以内で入力してください`,
  MIN_LENGTH: (length: number): string => `${length}文字以上で入力してください`,
  INCLUDE_LATIN: "英数字を含めてください",
  INCLUDE_LATIN_ONLY: "英数字のみで入力してください",
  NUMERIC_FORMAT: (precision: number, scale: number): string =>
    scale === 0
      ? `整数${precision - scale}桁で入力してください`
      : `整数${precision - scale}桁、小数${scale}桁で入力してください`,
};

